import Main from './Main';
import { RouteObject } from 'react-router-dom';

const route: RouteObject = {
  path: '/dashboard',
  children: [Main],
};
export default route;
